var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { ESendCodeType } from "../../enum/ESendCodeType";
import Component from 'vue-class-component';
import LoginService from "@/api/LoginService";
import CommonService from "@/api/CommonService";
var checkMsg = '发送验证码';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.qrcodeImg = '';
        _this.ticket = '';
        _this.loading = false;
        _this.loadingConfirm = false;
        _this.loadingCode = false;
        _this.isUnBindAccount = false;
        _this.isScan = false;
        _this.openId = '';
        _this.unionId = '';
        _this.checkMsg = checkMsg;
        _this.timeFlag = null;
        _this.loginForm = {
            phone: "",
            checkNo: "",
        };
        _this.isDestroyTimer = false;
        _this.isExpired = false;
        _this.timerDuration = 2000;
        _this.timerResult = null;
        _this.timerQrcode = null;
        return _this;
    }
    default_1.prototype.created = function () {
        this.isDestroyTimer = false;
        this.service = LoginService.getInstance();
        this.commonService = CommonService.getInstance();
        this.initQrcode();
    };
    default_1.prototype.beforeDestroy = function () {
        console.log('--------------清除定时器');
        this.isDestroyTimer = true;
        this.clearTimer();
    };
    default_1.prototype.clearTimer = function () {
        this.clearResultTimer();
        this.clearQrcodeTimer();
    };
    default_1.prototype.getScanResult = function () {
        var _this = this;
        this.clearResultTimer();
        this.service.getWechatScanResult({ ticket: this.ticket }).then(function (res) {
            var _a = res.data, data = _a.data, code = _a.code, msg = _a.msg;
            if (_this.isDestroyTimer) {
                _this.clearTimer();
                return;
            }
            if (code === 30009) {
                _this.isScan = true;
                _this.clearTimer();
                return _this.emitRegister(true, data);
            }
            else if (code === 30004) {
                return _this.$message.warning(msg);
            }
            if (data.token) {
                console.log('------scan login', res);
                _this.isScan = true;
                _this.clearTimer();
                return _this.$emit('login', data);
            }
            else if (data.openid) {
                _this.clearTimer();
                _this.isScan = true;
                _this.openId = data.openid;
                _this.unionId = data.unionid;
                _this.isUnBindAccount = true;
                return;
            }
            _this.timerResult = setTimeout(function () {
                _this.getScanResult();
            }, _this.timerDuration);
        }, function (res) {
            return _this.$message.warning(res.message);
        }).catch(function (res) {
        });
    };
    default_1.prototype.clearResultTimer = function () {
        clearInterval(this.timerResult);
    };
    default_1.prototype.clearQrcodeTimer = function () {
        clearInterval(this.timerQrcode);
    };
    default_1.prototype.getQrcodeStatus = function () {
        var _this = this;
        if (this.isUnBindAccount)
            return;
        this.clearQrcodeTimer();
        this.service.getWechatQrcodeStatus({ ticket: this.ticket }).then(function (res) {
            var is_expired = res.data.data.is_expired;
            if (is_expired || _this.isDestroyTimer) {
                _this.clearTimer();
                _this.isExpired = true;
                return;
            }
            console.log('------get scan status', res);
            _this.timerQrcode = setTimeout(function () {
                _this.getQrcodeStatus();
            }, _this.timerDuration);
        });
    };
    default_1.prototype.initQrcode = function () {
        var _this = this;
        this.clearQrcodeTimer();
        console.log('------initQrcode');
        this.isUnBindAccount = false;
        this.isScan = false;
        this.loading = true;
        this.service.getWechatQrcode({ type: 1 }).then(function (res) {
            _this.isExpired = false;
            var _a = res.data.data, url = _a.url, ticket = _a.ticket;
            _this.qrcodeImg = url;
            _this.ticket = ticket;
            _this.getScanResult();
            _this.getQrcodeStatus();
        }).finally(function () {
            _this.loading = false;
        });
    };
    default_1.prototype.clearFlag = function () {
        clearInterval(this.timeFlag);
        this.timeFlag = 0;
        this.checkMsg = checkMsg;
    };
    default_1.prototype.getCheckNo = function () {
        var _this = this;
        if (!/^\d{11}$/.test(this.loginForm.phone)) {
            return this.$message.warning('手机号格式有误');
        }
        if (this.timeFlag || this.loadingCode) {
            return;
        }
        this.loadingCode = true;
        this.commonService.sendCode({ phone: this.loginForm.phone, type: ESendCodeType.bindWechat }).then(function (res) {
            var _a = res.data, code = _a.code, success = _a.success;
            if (code === 71) {
                _this.$confirm('该账号未注册，是否立即注册', '提示', {})
                    .then(function () {
                    _this.$emit('register', { unionid: _this.unionId, openid: _this.openId, phone: _this.loginForm.phone });
                }, function () { });
            }
            else {
                var num_1 = 60;
                _this.checkMsg = num_1 + "s \u540E\u91CD\u8BD5";
                _this.timeFlag = setInterval(function () {
                    num_1--;
                    if (num_1 === 0) {
                        _this.clearFlag();
                    }
                    else {
                        _this.checkMsg = num_1 + "s \u540E\u91CD\u8BD5";
                    }
                }, 1000);
                _this.$message.success('发送成功！');
            }
        }, function (error) {
            console.log('------err', error);
            _this.$message.error(error.message);
        }).finally(function () {
            _this.loadingCode = false;
        });
    };
    default_1.prototype.emitRegister = function (isResubmit, data) {
        if (isResubmit === void 0) { isResubmit = false; }
        this.$emit('register', __assign({ isResubmit: isResubmit, unionid: this.unionId, openid: this.openId }, data));
    };
    default_1.prototype.confirm = function (isConfirm) {
        var _this = this;
        if (isConfirm === void 0) { isConfirm = false; }
        var data = {
            phone: this.loginForm.phone,
            sms_code: this.loginForm.checkNo,
            openid: this.openId,
            unionid: this.unionId,
            is_confirm: isConfirm
        };
        console.log('------confirm', isConfirm);
        this.loadingConfirm = true;
        this.service.bindAccmount(data).then(function (res) {
            var _a = res.data, data = _a.data, code = _a.code;
            if (data.token) {
                _this.$emit('login', data);
            }
            else if (code === 71) {
                _this.$confirm('该账号未注册，是否立即注册', '提示', {})
                    .then(function () {
                    _this.$emit('register', { unionid: _this.unionId, openid: _this.openId, phone: _this.loginForm.phone });
                }, function () { });
            }
            else if (code === 72) {
                _this.$confirm("\n        \u5F53\u524D\u5FAE\u4FE1\u53F7\u6216\u8D26\u53F7\u5DF2\u5B58\u5728\u7ED1\u5B9A\u5173\u7CFB\uFF0C\u662F\u5426\u7EE7\u7EED\u7ED1\u5B9A\uFF1F\n        \uFF08\u7EE7\u7EED\u7ED1\u5B9A\uFF0C\u5C06\u4F1A\u89E3\u7ED1\u4E4B\u524D\u7684\u7ED1\u5B9A\u5173\u7CFB\uFF09\n        ", '提示')
                    .then(function () {
                    _this.confirm(true);
                }, function () { });
            }
            else if (code === 30009) {
                _this.emitRegister(true, data);
            }
            console.log('------res', res);
        }, function (error) {
            _this.$message.error(error.message);
        }).finally(function () {
            _this.loadingConfirm = false;
        });
    };
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
